import { LIMPAR_FILTRO_FECHAMENTO_CAIXA } from '../types'

export default function limparFiltroFechamentoCaixa () {
  return {
    type: LIMPAR_FILTRO_FECHAMENTO_CAIXA
  }
}
